import * as React from "react";

function SvgScan(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 34" fill="none" {...props}>
      <path
        d="M2.833 0A2.833 2.833 0 000 2.833V11h3V4c0-.782.218-1 1-1h5V0H2.833zM23 0v3h5c.782 0 1 .218 1 1v7h3V3c0-1.565-1.435-3-3-3h-6zM32 23h-3v7c0 .782-.218 1-1 1h-5v3h6c1.565 0 3-1.435 3-3v-8zM9 34v-3H4c-.782 0-1-.218-1-1v-7H0v8c0 1.565 1.435 3 3 3h6zM24.347 11.334c-.993-.02-1.805.812-1.805 1.805V17h-.355V9.199c0-.993-.812-1.824-1.805-1.805a1.77 1.77 0 00-1.736 1.77V17h-.354V7.472c0-.993-.813-1.824-1.806-1.805a1.77 1.77 0 00-1.736 1.77V17h-.354V9.243c0-.993-.813-1.824-1.806-1.805a1.77 1.77 0 00-1.736 1.77v10.448l-1.4-1.927a1.77 1.77 0 00-2.865 2.083l5.56 7.646a2.124 2.124 0 001.719.875h8.747c.986 0 1.843-.678 2.069-1.638l1.173-4.988c.15-.637.226-1.29.226-1.946v-6.657a1.77 1.77 0 00-1.736-1.77z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgScan;
